import React, { useState } from "react";

const HowItWorkForm = () => {
  const [tipexampleVisible, setTipexampleVisible] = useState(false);

  return (
    <div>
      <h3 className="h-nomargin-bold margintop18">איך דאבל עובד?</h3>

      <div className="howItWork">
        <div className="faceline">
          <div className="aboutmeiconw"></div>

          <div>
            מעדכנים את הפרופיל שלכם בדאבל
            <div className="howItWork-note">
              מוסיפים פרטים ותמונה, ויש גם טיפים שיעזרו לכם להציג את עצמכם בצורה
              מיטבית.
            </div>
          </div>
        </div>

        <u
          className="howItWork-example"
          onClick={() => setTipexampleVisible(!tipexampleVisible)}
        >
          {tipexampleVisible ? "סגירת הדוגמה" : "לדוגמה"}
        </u>

        <div className={tipexampleVisible ? "tipexample" : "invisible"}></div>
      </div>

      <div className="rectangle"></div>
      <div className="triangle-down"></div>

      <div className="howItWork faceline">
        <div className="aboutpartnericonw"></div>
        <div>מגדירים את מי אתם מחפשים</div>
      </div>

      <div className="rectangle"></div>
      <div className="triangle-down"></div>

      <div className="howItWork faceline">
        <div className="doublematchicon"></div>
        <div>
          דאבל מחפש עבורכם
          <div className="howItWork-note">
            המערכת בודקת התאמות מתאימות, בלי לגלול בין מאות פרופילים.
          </div>
        </div>
      </div>

      <div className="rectangle"></div>
      <div className="triangle-down"></div>

      <div className="howItWork faceline">
        <div className="msgicon"></div>

        <div>
          קיבלתם התאמה חדשה
          <div className="howItWork-note">
            כשנמצאת התאמה מתאימה, תקבלו הודעה ותוכלו לצפות בפרופיל.
          </div>
        </div>
      </div>

      <div className="rectangle"></div>
      <div className="triangle-down"></div>

      <div className="howItWork faceline">
        <div className="heart-date"></div>

        <div>
          שניכם מעוניינים להכיר?
          <div className="howItWork-note">
            המערכת תעדכן את שניכם ותציג לכם את מספרי הטלפון, כדי שתוכלו ליצור
            קשר ישירות. אין צורך להתכתב באתר.
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorkForm;
